import { render, staticRenderFns } from "./NavPath.vue?vue&type=template&id=594ddd8e&xmlns%3Ael=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./NavPath.vue?vue&type=script&lang=js"
export * from "./NavPath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/alidata/server/jenkins/workspace/sunion-prod-web-os/03SRC/web-os/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594ddd8e')) {
      api.createRecord('594ddd8e', component.options)
    } else {
      api.reload('594ddd8e', component.options)
    }
    module.hot.accept("./NavPath.vue?vue&type=template&id=594ddd8e&xmlns%3Ael=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml", function () {
      api.rerender('594ddd8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/layout/NavPath.vue"
export default component.exports